import abandonedFarmSprite from '../assets/location_abandoned_farm_sprite.svg'
import cafePannekoekSprite from '../assets/location_cafe_pannekoek_sprite.svg'
import fashionStoresSprite from '../assets/location_fashion_stores_sprite.svg'
import oldMarketHallSprite from '../assets/location_old_market_hall_sprite.svg'
import ruralSupermarketSprite from '../assets/location_rural_supermarket_sprite.svg'
import townHallOfficesSprite from '../assets/location_town_hall_offices_sprite.svg'
import verkadeFactorySprite from '../assets/location_verkade_factory_sprite.svg'
import vinkelBridgeSprite from '../assets/location_vinkel_bridge_sprite.svg'
import type { LocationId } from './types'

const LOCATION_CARD_BACKGROUND_IMAGE: Record<LocationId, string> = {
  'vinkel-bridge': vinkelBridgeSprite,
  'rural-supermarket': ruralSupermarketSprite,
  'cafe-pannekoek': cafePannekoekSprite,
  'abandoned-farm': abandonedFarmSprite,
  'verkade-factory': verkadeFactorySprite,
  'town-hall-offices': townHallOfficesSprite,
  'fashion-stores': fashionStoresSprite,
  'old-market-hall': oldMarketHallSprite,
  'a2-highway-road': vinkelBridgeSprite,
  'a2-rest-stop-collapsed': ruralSupermarketSprite,
  'utrecht-domplein': verkadeFactorySprite,
  'utrecht-oudegracht': townHallOfficesSprite,
  'utrecht-centraal': fashionStoresSprite,
  'utrecht-jaarbeurs': oldMarketHallSprite,
  'utrecht-galgenwaard': abandonedFarmSprite,
  'utrecht-umc-fringe': cafePannekoekSprite,
  'utrecht-lombok': ruralSupermarketSprite,
  'utrecht-hoog-catharijne': verkadeFactorySprite,
  'utrecht-nieuwegracht': townHallOfficesSprite,
}

const LOCATION_CARD_BRIGHTNESS: Record<LocationId, string> = {
  'vinkel-bridge': 'brightness(0.9)',
  'rural-supermarket': 'brightness(0.85)',
  'cafe-pannekoek': 'brightness(0.92)',
  'abandoned-farm': 'brightness(0.9)',
  'verkade-factory': 'brightness(0.86)',
  'town-hall-offices': 'brightness(0.88)',
  'fashion-stores': 'brightness(0.92)',
  'old-market-hall': 'brightness(0.9)',
  'a2-highway-road': 'brightness(0.88)',
  'a2-rest-stop-collapsed': 'brightness(0.87)',
  'utrecht-domplein': 'brightness(0.85)',
  'utrecht-oudegracht': 'brightness(0.88)',
  'utrecht-centraal': 'brightness(0.86)',
  'utrecht-jaarbeurs': 'brightness(0.87)',
  'utrecht-galgenwaard': 'brightness(0.9)',
  'utrecht-umc-fringe': 'brightness(0.88)',
  'utrecht-lombok': 'brightness(0.89)',
  'utrecht-hoog-catharijne': 'brightness(0.84)',
  'utrecht-nieuwegracht': 'brightness(0.9)',
}

/** Backdrop for location cards: use `<img>` — SVG as CSS `background-image` is flaky with filters in WebKit. */
export function locationCardBackdrop(locationId: LocationId): {
  src: string
  brightnessFilter: string
} {
  return {
    src: LOCATION_CARD_BACKGROUND_IMAGE[locationId],
    brightnessFilter: LOCATION_CARD_BRIGHTNESS[locationId],
  }
}
